
export interface IModalState {
    config: { [key: string]: boolean };
}

export const MODAL_MUTATION_TYPES = {
    UPDATE_STATE_MODAL: "UPDATE_STATE_MODAL",
}

export const MODAL_ACTIONS = {
    UPDATE_STATE_MODAL: "UPDATE_STATE_MODAL",
}

export const MODAL_GETTERS = {
    GET_STATE_MODAL: "GET_STATE_MODAL"
}